<template>
  <div class="scatter-legend">
    <svgicon
      :name="icon"
      width="13"
      height="13"
      class="scatter-legend__icon"
      original
    ></svgicon>
    <p class="scatter-legend__label">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: "ScatterLegend",
  props: ["icon", "text"],
};
</script>

<style lang="scss" scoped>
.scatter-legend {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: toRem(14) toRem(19);
  @include dida-S;
  color: white;

  &__icon {
    margin-right: toRem(5);
  }
}
</style>
